<script setup lang="ts">

import { ArrowRight } from '@element-plus/icons-vue'
import type { cardType } from '@/stores/TypeIntertface'

const $emit = defineEmits(["clickCard"]);

var def = defineProps({
  backText: {
    type: Array<cardType>,
    default() {
      return [];
    },
  },
  isImg: {
    type: Boolean,
    default:false,
  },
  selectText: {
    type: String,
    default:'',
  },
  isFAQ: {
    type: Boolean,
    default:false,
  },
});
function cardClick(text: string) {

  $emit('clickCard', text);

}
</script>

<template>
  <div class="card-ctr" :class="isFAQ?'select-card':''">
<!--    <div class="card-img" v-if="isImg">-->
<!--      <img  src="@/assets/ask3.png" >-->
<!--    </div>-->
    <div v-if="isFAQ">
      <div class="card-title">
        <img style="width: 14px;height: 14px;margin-right: 4px"  src="@/assets/select-icon.png" alt="">
        您已选择的文本：
      </div>
      <div class="select-content">{{selectText}}</div>
    </div>
    <div class="card-list" >
      <div class="card-title">
        <img style="width: 14px;height: 14px;margin-right: 4px"  src="@/assets/card-icon.png" alt="">
        猜你想问：
      </div>
<!--      <a v-for="(file, index) in backText"-->
<!--         :key="index" class="card" :class="isImg?'hot':''" @click="cardClick(file?.content)">{{ file?.title }}</a>-->
      <div class="card-item" v-for="(file, index) in backText"
           :key="index" :class="isImg?'hot':''" @click="cardClick(file?.content)">

        <div style="width: 95%;">
          {{ file?.title }}
        </div>
        <el-icon><ArrowRight /></el-icon>
      </div>
      <div v-if="isFAQ">
        <p class="card-tip">或直接向我提问</p>

      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">
.select-card{
  position: absolute;
  bottom: 0;
  z-index: 100;
  width: 343px !important;
  margin-left: 7px !important;
  margin-right: 9px !important;
  max-width: 95% !important;
}
.card-ctr{
  max-width: 80%;
  min-width: 279px;
  background-color: #fff;
  width: fit-content;
  border-radius: 12px;

  overflow: hidden;
  //box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  margin-bottom: 16px;
  flex-direction: column;
  -webkit-animation: msgLeft .5s ease-in-out;
  animation: msgLeft .5s ease-in-out;
  margin-left: 41px;
  font-size: 14px;
}
.card-img{
  height: 128px;
  margin-top: 30px;
}
.card-img img{
  max-height: 100%;
  width: auto;
}
.card-list{
  width: 279px;
  flex: 1;
  min-width: 0;
  padding-bottom: 16px;
}
.hot:first-child::after{
  background: #FC7303;
  border-radius: 20px 20px 20px 2px;
  color: #fff;
  content: "hot";
  display: inline-block;
  font-size: 10px;
  height: 16px;
  line-height: 16px;
  margin-left: 2px;
  text-align: center;
  width: 22px;
}
.card{
  /* margin-left: 0.14rem; */
  padding: 14px;
  border-top: 1px solid #F2F2F2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  cursor:pointer;
}
.card:hover{
  background: #F6F6F6;
}
.card:first-child {
  border-top: 0;
}
.card-title{
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0px;
  font-feature-settings: "kern" on;
  color: #86909C;
  padding: 10px 12px 0px;
  display: flex;
  align-items: center
}
.card-item{
  background: #F6F6FB;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #F6F6FB;
  margin: 8px 12px;
  border-radius: 8px;
  line-height: 22px;
  padding: 5px 11px 5px 16px;
  justify-content: space-between;
  font-size: 14px;
  font-weight: normal;
  color: #4E5969;
  :deep(.el-icon){
    font-size: 12px;
  }
}
.card-item:hover{
  background: #E2E5FC;
  border: 1px solid #E2E5FC;
  cursor: pointer;
}

.select-content{
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #040A39;
  padding: 4px 12px;
  width: 100%;
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.card-tip{
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0px;
  font-feature-settings: "kern" on;
  color: #86909C;
  padding-left: 20px;
}
</style>